/*
Recursively check whether any props of object or its children hold primitive value.
Not safe to be used for objects with circular reference
* */
const objectHoldsAnyPrimitiveValue = (obj: any) => Object.keys(obj).some(key => {
  let childHoldsPrimitiveValue = false
  let holdsPrimitiveValue = false
  if (typeof obj[key] === 'object') {
    childHoldsPrimitiveValue = objectHoldsAnyPrimitiveValue(obj[key])
  } else if (obj[key]) {
    holdsPrimitiveValue = true
  }
  return holdsPrimitiveValue || childHoldsPrimitiveValue
})

export default objectHoldsAnyPrimitiveValue
